// extracted by mini-css-extract-plugin
export var lightMode = "_1s-0";